import {AxiosService} from '@/service/axios.service';
import {KRBS_CIRCULARS} from '@/config/constants.config';
import {AppService} from '@/service/app.service';
import {AlertService} from '@/service/alert.service';
import {toLower} from 'lodash';

const state = {
  circular_issues: [],
  circular_issues_archive: [],
  selected_circular_issue: [],
};
const mutations = {
  SET_CIRCULAR_ISSUE(state, circular_issues) {
    state.circular_issues = circular_issues;

    // let tempVal = {id: 3, name: 'ARCHIVE'};
    //
    // state.circular_issues = circular_issues.map(u => u.id !== tempVal.id ? u : tempVal);


  },

  SET_CIRCULAR_ISSUE_ARCHIVE(state, circular_issues_archive) {
    state.circular_issues_archive = circular_issues_archive;
  },


  SET_SELECTED_ISSUE: (state, payload) => {
    state.selected_circular_issue = payload ?? state.circular_issues[0];
  },

};

const actions = {
  async getCircularIssues({commit, rootState}) {
    let userType = toLower(rootState.AuthModule.authUser.scope);
    commit('SET_CIRCULAR_ISSUE', []);
    await AxiosService.get(userType + KRBS_CIRCULARS.CIRCULAR_ISSUES.KEYS).then(r => {
      commit('SET_CIRCULAR_ISSUE', r.data.data);
      commit('SET_SELECTED_ISSUE', null);
    }).catch((e) => {
      AlertService.responseAlertMessage(e, 'GET CIRCULAR ISSUES');
      return e;
    });
  },

  async getCircularIssuesArchive({commit, rootState}) {
    let userType = toLower(rootState.AuthModule.authUser.scope);
    commit('SET_CIRCULAR_ISSUE_ARCHIVE', []);
    await AxiosService.get(userType + KRBS_CIRCULARS.CIRCULAR_ISSUES.KEYS_ARCHIVE).then(r => {
      commit('SET_CIRCULAR_ISSUE_ARCHIVE', r.data.data);
      commit('SET_SELECTED_ISSUE', null);
    }).catch((e) => {
      AlertService.responseAlertMessage(e, 'GET CIRCULAR ISSUES');
      return e;
    });
  },

};
const getters = {
  circular_issues: (state) => AppService.capitalizeProperties(state.circular_issues),
  circular_issues_archive: (state) => AppService.capitalizeProperties(state.circular_issues_archive),
  selected_circular_issue: (state) => state.selected_circular_issue,
};

export default {state, actions, mutations, getters};
